import createImagePixelArray from './createImagePixelArray';
import createImageHistogramPalette from './createImageHistogramPalette';

import { rgbToHex } from '../../../../common/colors/colorSpaceUtil';
import globalLogger from '../../../logger';
import fetchImageDataFromUrl from './fetchImageDataFromUrl';

const logger = globalLogger.createChannel('images.color-palette');

const getColorPaletteFromUrl = async (url) => {
    try {
        // Every platform reads the pixels straight off the remote image. Native used to download the
        // bytes into a blob first, only because an anonymous cross-origin load couldn't authenticate
        // permission-checked media; fetchImageDataFromUrl now loads those credentialed instead.
        const imageData = await fetchImageDataFromUrl(url);

        const pixelCount = imageData.width * imageData.height;
        const pixelArray = createImagePixelArray(new Uint8Array(imageData.data), pixelCount, 20);
        const histogramPalette = createImageHistogramPalette(pixelArray);

        return histogramPalette.map(rgbToHex);
    } catch (error) {
        logger.error('Failed to extract image color palette', error);
        return [];
    }
};

export default getColorPaletteFromUrl;
